var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"close_detail",staticStyle:{"background-image":"url('img/close_detail.png')","width":"100vw","background-repeat":"no-repeat","background-size":"100% 100%"}})}
var staticRenderFns = []

export { render, staticRenderFns }